<template>
  <layout title="Новости">
    <div class="card">
      <div class="card-header bg-white">
        <h4 class="mb-0">
          Новости
          <Link
              :class="{disabled: ! $page.props.can.news.create}"
              :href="route('backend.news.create')" class="btn btn-outline-success btn-sm float-right">
            <font-awesome-icon icon="plus"/>
            Добавить новость
          </Link>
        </h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col">
            <search-filter v-model="searchQuery" placeholder="Поиск по заголовку новости" autofocus
                           class="mb-3"></search-filter>
          </div>
          <div class="col-4">
            <b-form-select v-model="searchStatus" :options="statusOptions"></b-form-select>
          </div>
        </div>

        <table class="table table-borderless table-sm table-grid">
          <thead>
          <tr>
            <th class="fit">ID</th>
            <th class="fit">Создание</th>
            <th class="fit">Обновление</th>
            <th class="fit">Статус</th>
            <th>Заголовок</th>
            <th class="fit"></th>
            <th class="fit"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item) in collection.data" :key="item.id">
            <td>
              <small class="text-muted">{{ item.id }}</small>
            </td>
            <td>{{ item.created_at }}</td>
            <td class="fit">{{ item.updated_at }}</td>
            <td>{{ item.is_published ? 'Опубликовано' : 'Черновик' }}</td>
            <td>{{ item.title }}</td>
            <td>
              <a class="btn btn-sm btn-outline-secondary" :class="{disabled: !item.is_published}"
                 :href="item.url" target="_blank">Просмотр</a>
            </td>
            <td>
              <div class="btn-group btn-group-sm" role="group">
                <Link class="btn btn-outline-secondary"
                              :class="{disabled: ! item.can.update}"
                              :href="route('backend.news.edit', item.id)">
                  <font-awesome-icon icon="pen"/>
                </Link>

                <b-btn variant="outline-secondary"
                       :disabled="! item.can.delete"
                       @click="onDelete(item.id)">
                  <font-awesome-icon icon="trash"/>
                </b-btn>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
        <nav v-if="collection.meta">
          <ul class="pagination pagination-sm">
            <li v-for="page in Math.ceil(collection.meta.total / collection.meta.per_page)" :key="page" class="page-item"
                :class="page === collection.meta.current_page ? 'active' : ''">
              <Link class="page-link" :href="`${collection.meta.path}?page=${page}${getQueryParams()}`">
                {{ page }}
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '~/Layouts/Layout'
import SearchFilter from '~/Components/SearchFilter'
import debounce from 'lodash/debounce'

export default {
  components: {
    Layout,
    SearchFilter
  },
  props: {
    search: String,
    status: String,
    collection: Object
  },
  data () {
    return {
      searchStatus: this.status,
      statusOptions: [
        {
          value: null,
          text: 'Все'
        },
        {
          value: 1,
          text: 'Опубликованные'
        },
        {
          value: 0,
          text: 'Черновик'
        }
      ],
      searchQuery: this.search,
      pagination: this.collection.meta || null
    }
  },
  watch: {
    searchQuery: debounce(function (val, oldVal) {
      if (val === oldVal) {
        return
      }

      this.$inertia.replace(
        this.route('backend.news.index', {
          search: this.searchQuery,
          status: this.searchStatus
        }))
    }, 200),

    searchStatus: debounce(function (val, oldVal) {
      if (val === oldVal) {
        return
      }

      this.$inertia.replace(
        this.route('backend.news.index', {
          search: this.searchQuery,
          status: this.searchStatus
        }))
    }, 200)
  },

  methods: {
    onDelete (orderId) {
      if (!confirm('Вы уверены?')) {
        return
      }

      this.$inertia.delete(this.route('backend.news.destroy', orderId))
    },

    getQueryParams () {
      const params = (new URL(document.location)).searchParams
      params.delete('page')

      const queryStr = params.toString()

      return queryStr.length > 0 ? '&' + queryStr : ''
    }
  }
}
</script>
